// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7424":"fb783d94","7459":"b0d3bf66"}[chunkId] + ".chunk.css";
};